// One heading treatment for every homepage section: a two-tone heading where
// the muted first line names the subject and the full-ink line makes the
// claim, both at the same size so they read as one sentence with emphasis.
//
// This replaces the old "01 / label" eyebrow-plus-number header. The numbers
// never carried information (the sections are not a sequence a reader follows)
// and a small label above a heading just repeats what the heading says. The
// `index` prop is still accepted so call sites don't break, but it is ignored.
// eslint-disable-next-line no-unused-vars
export default function SectionHeader({ index, label, title, lede, className = '' }) {
  return (
    <div className={className}>
      <h2 className="t-h2 max-w-[24ch] md:max-w-[28ch]">
        {label ? <span className="block text-muted">{label}</span> : null}
        <span className="block">{title}</span>
      </h2>

      {lede && <p className="t-lede mt-4">{lede}</p>}
    </div>
  )
}
